import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
  } from "reactstrap";
const ModaMobileLogin = () => {
  return null;
};

export default ModaMobileLogin;
